import { Image } from "shared/types"

export type HostName = 'Liz' | 'Kelly' | 'AJ'

interface HostInfo {
  name: HostName
  role: string
  bio: string
  shortBio: string
  image?: Image
}

export const HOSTS: HostInfo[] = [
  {
    name: 'Liz',
    role: 'The Storyweaver',
    bio: 'A radio broadcast professional, rum aficionado, and mum of one. Liz is bringing chaos to the proceedings. ',
    shortBio: "Radio Sales, Mama Bear, and Amateur Homesteader",
    image: {
      src: '/images/hosts/Liz.jpeg',
      alt: 'Liz laughing while looking off camera.'
    }
  },
  {
    name: 'Kelly',
    role: 'The Prism Witch',
    bio: "An optometric assistant by day, mixed media artist by night, and mom in the margins, Kelly bends light, color, and perception into something entirely her own. She keeps an eye on the details while happily derailing the conversation.",
    shortBio: "Optometric Assistant, Artist, and Professional Derailer",
    image: {
      src: '/images/hosts/Kelly.jpg',
      alt: 'Kelly in a dress, standing on the beach holding a lace fan'
    }
  },
  {
    name: 'AJ',
    role: 'The Artifex',
    bio: 'A software developer, general hobbiest, and wine connoisseur. AJ stitches together code and craft with mythic precision, and brings a mom\'s sleepless wisdom to every episode',
    shortBio: "Developer, Craft Addict, and Chaos Coordinator",
    image: {
      src: '/images/hosts/AJ.jpg',
      alt: 'AJ standing in front of curtains in a dress holding their pregnant belly'
    }
  },
];